export const AuxiloLogo = () => (
  <img width="272" alt="Auxillo Logo" src="/images/Auxilo-logo.webp" />
)
